// ConditionScoreView._mock.ts
// Types and config for ConditionScoreView

export interface ConditionSubfactor {
  urgency: "Critical" | "Urgent" | "Moderate" | "Low" | "Monitor";
  bt: boolean;
  cost: string;
  issueId?: string;
  description?: string;
}

export interface RepairEconomicsMock {
  totalCost: number;
  weightedCost: number;
  burdenPct: number;
  repairBurdenScore: number;
}

export interface RepairRow {
  label: string;
  valueKey: keyof RepairEconomicsMock | "repairRatio";
  format: (v: number) => string;
  tip: string;
}

export const REPAIR_ROWS: RepairRow[] = [
  {
    label: "Estimated Repair Cost",
    valueKey: "totalCost",
    format: (v) => `$${Math.round(v).toLocaleString()}`,
    tip: "Sum of midpoint cost estimates for all inspection remarks. Represents the baseline cost to address every identified deficiency.",
  },
  {
    label: "Urgency-Adjusted Cost",
    valueKey: "weightedCost",
    format: (v) => `$${Math.round(v).toLocaleString()}`,
    tip:
      "Repair costs weighted by urgency level. Critical items (2.5×), Urgent (1.5×), Moderate (1×), Low (0.5×), " +
      "Monitor (0×). Reflects the true financial risk profile.",
  },
  {
    label: "Repair / Price Ratio",
    valueKey: "repairRatio",
    format: (v) => `${v.toFixed(1)}%`,
    tip: "Estimated repair cost as a percentage of list price. Industry benchmark: under 3% is move-in ready, 3–8% is typical, over 8% is high burden.",
  },
  {
    label: "Adjusted Burden",
    valueKey: "burdenPct",
    format: (v) => `${v.toFixed(1)}%`,
    tip:
      "Urgency-adjusted repair cost as a percentage of list price. This is the primary measure of financial " +
      "exposure — higher values indicate more concentrated, high-urgency repairs.",
  },
  {
    label: "RepairBurden Score",
    valueKey: "repairBurdenScore",
    format: (v) => `${v}/100`,
    tip: "The final RepairBurden subscore (0–100, higher is better). A score of 42 indicates above-average repair burden relative to comparable properties.",
  },
];

export const API_TO_MOCK_CAT: Record<string, string> = {
  structural: "STRUCTURAL",
  exterior: "EXTERIOR",
  interior: "INTERIOR",
  hvac: "HVAC_SYSTEMS",
  hvac_systems: "HVAC_SYSTEMS",
  plumbing: "PLUMBING",
  electrical: "ELECTRICAL",
};
